import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';
import logoDefault from '../assets/almaquinta.svg';

const Login = () => {
    const { login, error } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const [localError, setLocalError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const logoUrl = logoDefault;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalError('');
        setLoading(true);

        const result = await login(email, password, rememberMe);

        if (!result.success) {
            setLocalError(result.error || 'Error al iniciar sesion');
        }

        setLoading(false);
    };

    return (
        <div className="galaxy">
            <div className="stars" />
            <div className="nebula" />

            <div className="login-container">
                <div className="card login-card">
                    <div className="login-header">
                        <img src={logoUrl} alt="Don Presupuesto" className="login-logo" />
                        <h1 className="login-title">Don Presupuesto</h1>
                        <p className="login-subtitle">Ingresa tus credenciales para continuar</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        {(localError || error) && (
                            <div className="login-error">
                                {localError || error}
                            </div>
                        )}

                        <label className="field">
                            <span className="label">Email</span>
                            <input
                                className="input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="tu@email.com"
                                required
                                autoFocus
                            />
                        </label>

                        <label className="field">
                            <span className="label">Contraseña</span>
                            <div className="input-password-wrap">
                                <input
                                    className="input"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Tu contraseña"
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex={-1}
                                >
                                    {showPassword ? (
                                        <EyeOff size={20} />
                                    ) : (
                                        <Eye size={20} />
                                    )}
                                </button>
                            </div>
                        </label>

                        <label className="checkbox-field">
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <span>Mantener sesión iniciada</span>
                        </label>

                        <button
                            className="btn neon login-btn"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Ingresando...' : 'Ingresar'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
